export default "__VITE_ASSET__BAmGjxVv__"